import { useMediaQuery } from "@mui/material"
import EquityWeb from "./EquityWeb"
import EquityMob from "./EquityMob"
export default function Equity() {
    const isSmallScreen = useMediaQuery("(max-width:1000px)");

    return isSmallScreen ? <EquityMob /> : <EquityWeb />;

}